import { defineMessages } from 'react-intl';

export default defineMessages({
  monday: {
    id: 'monday',
    defaultMessage: 'Monday',
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: 'Tuesday',
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: 'Wednesday',
  },
  thursday: {
    id: 'thursday',
    defaultMessage: 'Thursday',
  },
  friday: {
    id: 'friday',
    defaultMessage: 'Friday',
  },
  saturday: {
    id: 'saturday',
    defaultMessage: 'Saturday',
  },
  sunday: {
    id: 'sunday',
    defaultMessage: 'Sunday',
  },
});
